import { observer } from 'mobx-react';
import * as React from 'react';
import { action } from 'mobx';
import { bind } from '../../../../utils/decorators';
import { inject } from '../../../../utils/decorators';
import { BpsReferenzkraftKalibrierungPlatteStore } from '../../../../stores/BpsReferenzkraftKalibrierungPlatteStore';
import { Panel, Table, FormControl, InputGroup } from 'react-bootstrap';

@observer
class BpsReferenzkraftWaegezelleMesspunkt extends React.Component<{ index: number }, {}> {

  @inject(BpsReferenzkraftKalibrierungPlatteStore) store: BpsReferenzkraftKalibrierungPlatteStore;

  @bind @action handleValueChanged(index: number, ev: React.FormEvent<FormControl>) {
    this.store.datensatz.waegezelle.messwerte[index] = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).valueAsNumber : undefined;
  }
  imToleranzbereich(wert: number | undefined) {
    const { waegezelle } = this.store.datensatz;
    if (wert === undefined) {
      return false;
    }
    return ((wert >= waegezelle.sollwert - waegezelle.toleranz) && (wert <= waegezelle.sollwert + waegezelle.toleranz));
  }
  render() {
    const { waegezelle } = this.store.datensatz;
    return (
      <tr>
        <td>
          {this.props.index + 1}.Messung
        </td>
        <td className="sollwert">
          {waegezelle.sollwert}
        </td>
        <td className="messwert">
          <InputGroup>
            <FormControl
              type="number"
              step="0.1"
              readOnly={this.store.readOnly}
              value={waegezelle.messwerte[this.props.index] ? waegezelle.messwerte[this.props.index] : ''}
              onChange={(e) => this.handleValueChanged(this.props.index, e)}
              className={this.imToleranzbereich(waegezelle.messwerte[this.props.index]) ? 'text-success' : 'text-danger'}
            />
            <InputGroup.Addon>N</InputGroup.Addon>
          </InputGroup>
        </td>
        <td className="toleranz">
          ± {waegezelle.toleranz} N
        </td>
      </tr>
    );
  }
}

/** Exportierte Komponente für Eingabe und Validierung der Wägezelle */
@observer
export default class BpsReferenzkraftWaegezelle extends React.Component<{}, {}> {

  @inject(BpsReferenzkraftKalibrierungPlatteStore) store: BpsReferenzkraftKalibrierungPlatteStore;

  render() {
    const { waegezelle } = this.store.datensatz;
    return (
      <Panel header="Überprüfung der Wägezelle" collapsible={true} defaultExpanded={true}>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-waegezelle">
          <thead>
            <tr>
                <th/>
                <th>Soll</th>
                <th>Messwert</th>
                <th>Toleranz</th>
            </tr>
          </thead>
          <tbody>
            {waegezelle.messwerte.map((mp, index) =>
              <BpsReferenzkraftWaegezelleMesspunkt key={index} index={index}/>
            )}
          </tbody>
        </Table>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/platte/BpsReferenzkraftWaegezelle.tsx